import router from '@/router'
import { data_v2_statis } from '@/api/portal'

const state = {
  selectLocId:'',
  selectLocName:'',
  statisData:{}
}

const mutations = {


  setSelectLocId(state,locId,locName){
    state.selectLocId = locId
    state.selectLocName = locName
  }
}

const actions = {
  // 获取数据概况
  async getStatis({state}) {
    let {data} = await data_v2_statis({
      locId:state.selectLocId
    })
    state.statisData = data
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
